"use client";

import Image from "next/image";
import Link from "next/link";

export default function Footer() {
  return (
    <footer className="py-12 bg-white dark:bg-[#0a0a0a] border-t border-gray-100 dark:border-gray-800">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div className="col-span-2">
            <div className="flex items-center gap-2 mb-6">
              <Image
                src="/logo.png"
                alt="CaratPay Logo"
                width={28}
                height={28}
                className="rounded-md"
              />
              <span className="text-lg font-bold text-[#6b5a1a] dark:text-[#C9A227]">CaratPay</span>
            </div>
            <p className="text-gray-500 dark:text-gray-400 max-w-sm leading-relaxed">
              CaratPay is owned and operated by Venture Sona Technologies Pvt
              Ltd.
            </p>
          </div>
          <div>
            <h3 className="font-bold text-[#1a1a1a] dark:text-white mb-6">
              Legal
            </h3>
            <ul className="space-y-4">
              <li>
                <Link
                  href="/privacy-policy"
                  className="text-sm text-gray-500 dark:text-gray-400 hover:text-[#6b5a1a] dark:hover:text-[#C9A227] transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  href="/terms-and-conditions"
                  className="text-sm text-gray-500 dark:text-gray-400 hover:text-[#6b5a1a] dark:hover:text-[#C9A227] transition-colors"
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link
                  href="/shipping-and-refund-policy"
                  className="text-sm text-gray-500 dark:text-gray-400 hover:text-[#6b5a1a] dark:hover:text-[#C9A227] transition-colors"
                >
                  Shipping, Cancellation & Refund Policy
                </Link>
              </li>
              <li>
                <Link
                  href="/delete-account"
                  className="text-sm text-gray-500 dark:text-gray-400 hover:text-[#6b5a1a] dark:hover:text-[#C9A227] transition-colors"
                >
                  Delete Account
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-bold text-[#1a1a1a] dark:text-white mb-6">
              Contact
            </h3>
            <ul className="space-y-4">
              <li className="text-gray-500 dark:text-gray-400">
                Bangalore, India
              </li>
              <li className="text-gray-500 dark:text-gray-400">
                contact@caratpay.co.in
              </li>
            </ul>
          </div>
        </div>
        <div className="pt-8 border-t border-gray-100 dark:border-gray-800 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-sm text-gray-500 dark:text-gray-400">
            © {new Date().getFullYear()} CaratPay. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <iframe
              src="https://dunsregistered.dnb.com/SealAuthentication.aspx?Cid=1"
              width="114"
              height="97"
              className="border-none w-[114px] h-[97px]"
              scrolling="no"
              title="D-U-N-S Registered Seal"
            />
            <iframe
              src="https://dunsregistered.dnb.com/SealAuthentication.aspx?Cid=1&QR=1"
              width="114"
              height="97"
              className="border-none w-[114px] h-[97px]"
              scrolling="no"
              title="D-U-N-S Registered QR Code"
            />
          </div>
        </div>
      </div>
    </footer>
  );
}
